<template>
  <!-- BEGIN: Content-->
  <div class="app-content content " style="display: flex; flex-direction: column; min-height: 95vh;">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Stores" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="mr-2 mt-2 ">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      @click="triggerAddStoreModal"
                  >

                    <svg enable-background="new 0 0 50 50" height="16" id="Layer_1" version="1.1" viewBox="0 0 50 50" width="16" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <rect fill="none" height="50" width="50"/>
                      <line fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="4" x1="9" x2="41" y1="25" y2="25"/>
                      <line fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="4" x1="25" x2="25" y1="9" y2="41"/>
                    </svg>


                    Onboard
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
              url="v1/get-store"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :mutedData="mutedData"
              customClass="table-hover-animation"
          />
        </div>
      </div>
    </div>
    <AddStoreModal :show="showAddModal" @hide="showAddModal = false" />
    <StoreLogsModal :show="showLogsModal" :data="selectedDetails" @hide="showLogsModal = false" />
  </div>
</template>


<script>


import {random} from "lodash";
import AddStoreModal from "@/pages/dashboard/store/AddStoreModal.vue";
import StoreLogsModal from "@/pages/dashboard/store/StoreLogsModal.vue";

export default {
  components: {StoreLogsModal, AddStoreModal},
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Store'},
      ],
      showAddModal:false,
      showLogsModal:false,
      selectedDetails: [],
      tableHeaderValues: [
        {
          title: 'Name',
          valueKey: 'name',
          html: true,
          alter: function (value) {
            return value
          }
        },
        {
          title: 'Code',
          valueKey: 'code',
          html: true,
          alter: function (value) {
            return value
          }
        },
        {
          title: 'Status',
          valueKey: 'status',
          html: true,
          alter:  (value,row) => {
            var html = ''
            if (value == 0)
              html = `<div class="badge badge-pill  badge-glow badge-light-warning">Deactive</div>`
            else if(value == 1)
              html = `<div class="badge badge-pill  badge-glow badge-light-success">Active</div>`
            else if(value == 2)
              html = `<div class="badge badge-pill  badge-glow badge-light-danger">Request For Changes</div>`
            else if(value == 3)
              html = `<div class="badge badge-pill  badge-glow badge-light-info">Pending Approval</div>`
            else if(value == 4)
              html = `<div class="badge badge-pill  badge-glow badge-light-secondary">Draft</div>`

            // if(row.type == 0){
            //   html = `
            //     <div class="row">
            //         <div class="col-12 ">
            //            ${html}
            //             <div class="badge badge-light-primary mt-1">Default</div>
            //         </div>
            //     </div>
            //     `
            // }

            if(value == 2){
              html = `
                <div class="row">
                    <div class="col-12 ">
                        ${html}
                        <div class="badge text-primary mt-1">View Comments For More Details</div>
                    </div>
                </div>
                `
            }

            if(row.type == 0 && value == 4){
              html = `
                <div class="row">
                    <div class="col-12 ">
                       <div class="row">
                          <div class="col-12 ">
                              <div class="badge badge-light-dark mt-1">Pending</div>
                              <div class="badge badge-light-primary mt-1">Default</div>
                          </div>
                      </div>

                        <div class="badge text-warning mt-1">Please complete store onboarding for store</div>
                    </div>
                </div>
                `
            }



            return html


          }
        },
        {
          title: 'Created At',
          valueKey: 'created_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
        {
          title: 'Updated At',
          valueKey: 'updated_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
      ],
      actions: [
        {
          title: 'View/Update Store Onboarding',
          class: 'badge badge-primary ',
          cta: (row) => {
            this.$store.commit('setCurrentStoreActivation', row);

            this.$router.push({name: 'update-account-activation'})
          }
        },
        {
          title: 'View Comments',
          class: 'badge badge-primary ml-1',
          cta: (row) => {
           this.selectedDetails = row.details ?? []
            this.showLogsModal = true
          }
        },
      ],
      mutedData: [],
    }
  },
  methods: {
    triggerAddStoreModal(){
      this.showAddModal = true
    }

  }
}
</script>

